import { gql } from '@apollo/client';

import DataSourceResultFormatType from '../../types/dataSource';
import { CustomerFileDocumentConnectorType } from '../types/documentConnector';

// QUERIES

export type FetchDocumentConnectorsResultType = {
	document_connectors: DataSourceResultFormatType<CustomerFileDocumentConnectorType>;
};
export type FetchDocumentConnectorsVariablesType = {
	page: {
		offset: number;
		limit: number;
	};
	search?: string;
};

export const FETCH_DOCUMENT_CONNECTORS = gql`
	query Document_connectors($page: Page, $search: String) {
		document_connectors(page: $page, search: $search) {
			count
			items {
				code
				name
			}
			limit
			offset
		}
	}
`;
